module.exports = __webpack_public_path__ + "img/38148bf.png";